<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-people"></i>
                            <span>{{$t('pending_evaluations.title')}}</span>
                        </h2>
                    </div>
                    <div class="panel__body">
                        <pending-evaluations-table />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import PendingEvaluationsTable from '@/components/tables/pending-evaluations/PendingEvaluationsTable';

    @Component({
        components: {
            PendingEvaluationsTable,
        }
    })
    export default class PendingEvaluations extends Vue {
        name = 'pending-evaluations';
    }

    Vue.component('pending-evaluations', PendingEvaluations);
</script>



// WEBPACK FOOTER //
// src/pages/PendingEvaluations.vue